import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/storage';
import * as admin from 'firebase-admin';
const serviceAccount = require('./aiesec-village-firebase-adminsdk-6cp7p-54eb93ec3a.json');

admin.initializeApp({
  credential: admin.credential.cert(serviceAccount),
  databaseURL: 'https://aiesec-village.firebaseio.com',
});
const firebaseConfig = firebase.initializeApp({
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  databaseURL: process.env.REACT_APP_FIREBASE_DATABASE_URL,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
});
export const db = firebase.firestore();
export const auth = firebaseConfig.auth();
export const storage = firebase.storage().ref();
export default firebaseConfig;
